import { createSelector, createSlice } from "@reduxjs/toolkit";
import { AppDispatch } from "@src/redux/store";
import { useDispatch, useSelector } from "react-redux";

const initialState: any = {
  data: {},
  loading: false
};

const slice = createSlice({
  name: "dynamic",
  initialState: initialState,
  reducers: {
    _set_state: (state, { payload: { key, value } }) => {
      state.data[key] = value;
    },
    _clear_state: (state, { payload: { key } }) => {
      state.data[key] = null;
    },
    _remove_state: (state, { payload: { key } }) => {
      let data = state.data;
      data = JSON.parse(JSON.stringify(data));
      delete data[key];
      state.data = data;
    }
  }
});

const { _set_state, _clear_state, _remove_state } = slice.actions;

export const dynamicSelector = (state: any) => state.dynamic;

export const dynamicReducer = slice.reducer;

const _getDynamicRequest = (state: any) => state.dynamic?.data;

export const _dynamicRequestSelector = createSelector(
  [_getDynamicRequest, (state, key) => key],
  (data, key) => data?.[key]
);

export function useReduxDispatch() {
  const dispatch = useDispatch<AppDispatch>();
  return dispatch;
}

export function useDynamicSelector(key: string) {
  const _data = useSelector((state) => _dynamicRequestSelector(state, key));
  return _data || {};
}

export function dynamicSet(key: string, value: any) {
  return async (dispatch: any) => {
    dispatch(_set_state({ key, value }));
  };
}

export function dynamicClear(key: string) {
  return async (dispatch: any) => {
    dispatch(_clear_state({ key }));
  };
}

export function dynamicRemove(key: string) {
  return async (dispatch: any) => {
    dispatch(_remove_state({ key }));
  };
}